import { useIntl } from 'react-intl'
import LayoutContainer from 'components/Common/LayoutContainer'
import Pane from 'components/Common/Pane'
import PaneBody from 'components/Common/Pane/PaneBody'
import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import styled from 'styled-components'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { rem } from 'polished'
import TextLink from 'LuxKit/TextLink'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import LinePhoneIcon from 'LuxKit/Icons/line/LinePhoneIcon'
import LineFastMailIcon from 'LuxKit/Icons/line/LineFastMailIcon'
import LineCommentsAltIcon from 'LuxKit/Icons/line/LineCommentsAltIcon'
import config from 'constants/config'
import { isolatePhoneNumber } from 'lib/format/formatPhoneNumber'

const SameHeightPaneSm = styled(Pane)`
  margin-top: ${rem(32)};

  ${mediaQueryUp.tablet} {
    margin-top: 0;
    height: 100%;
  }
`

const ContactContent = styled(PaneBody)`
  display: grid;

  ${mediaQueryUp.tablet} {
    grid-template-columns: repeat(3, 1fr);
  }
`

const Root = styled(VerticalSpacer)`
  text-align: center;
`

const CONTACT_ITEMS = [
  { Icon: LinePhoneIcon, link: 'tel:1300820853' },
  { Icon: LineFastMailIcon, link: 'mailto:sales@luxuryescapes.com' },
  { Icon: LineCommentsAltIcon, link: '/support' },
] as const

function CruisesContact() {
  const intl = useIntl()

  const contactTranslations: Record<string, { title: string; text: string; subText: string }> = {
    'tel:1300820853': {
      title: intl.formatMessage({
        id: 'xNnpN62HaJA_ZlcQ7I3O',
        defaultMessage: 'Call us',
      }),
      text: intl.formatMessage({
        id: 'xDzerbMCd8X8m6WITUyO',
        defaultMessage: 'Found a better price? Please contact us, we’ll match it!',
      }),
      subText: intl.formatMessage({
        id: 'GBPiOQXRBz7z9pQCpom-',
        defaultMessage: 'Call {phoneNumber}',
      }, { phoneNumber: isolatePhoneNumber(config.PRIORITY_SUPPORT_NUMBER_CRUISES) }),
    },
    'mailto:sales@luxuryescapes.com': {
      title: intl.formatMessage({
        id: 'ba9XfwCoef_Gjn36-N6H',
        defaultMessage: 'Email us',
      }),
      text: intl.formatMessage({
        id: 'YKSIKFMiaJmqNjprE_gZ',
        defaultMessage: 'The Gift Card will be sent by email for you to print or forward to the lucky recipient.',
      }),
      subText: intl.formatMessage({
        id: '0fOUVhu2Vn-66BzaY1ql',
        defaultMessage: 'Send an email',
      }),
    },
    '/support': {
      title: intl.formatMessage({
        id: 'Dn2OnwxP2JhMYhDgewGR',
        defaultMessage: 'Chat with us',
      }),
      text: intl.formatMessage({
        id: 'Txgo3vQgEmAa4HfmeFLP',
        defaultMessage: 'Need an answer right away? Chat live with a consultant now.',
      }),
      subText: intl.formatMessage({
        id: '3IfBSUXOhE8cXNdDXdys',
        defaultMessage: 'Chat now',
      }),
    },
  }

  return <Pane>
    <PaneBody size="xl-y md">
      <LayoutContainer>
        <Heading variant="heading2" align="center" as="h2">
          {intl.formatMessage({
            id: 'bMoYoNdMkRn-B-vnK9l-',
            defaultMessage: 'Need help? Get in touch with us.',
          })}
        </Heading>
        <ContactContent size="xl-y">
          {CONTACT_ITEMS.map(({ Icon, link }) => {
            const { title, text, subText } = contactTranslations[link]
            return (
              <SameHeightPaneSm key={link}>
                <PaneBody size="lg xl-y">
                  <Root gap={16}>
                    <Icon size={30} colour="primary" />
                    <div>
                      <BodyText variant="medium" weight="bold">
                        {title}
                      </BodyText>
                      <BodyText variant="small" as="p">
                        {text}
                      </BodyText>
                      <TextLink size="small" weight="bold" href={link}>
                        {subText}
                      </TextLink>
                    </div>
                  </Root>
                </PaneBody>
              </SameHeightPaneSm>
            )
          })}
        </ContactContent>
      </LayoutContainer>
    </PaneBody>
  </Pane>
}

export default CruisesContact
